import { forwardRef } from 'react';

import classNames from 'classnames';

import soundEffects from '../../services/sounds/soundEffects';

import './Button.scss';
import type { IOldButtonProps } from './buttonTypes';

export const OldButton = forwardRef<HTMLButtonElement, IOldButtonProps>(
  (
    {
      className,
      classNameWrapper = '',
      classNameContent,
      btnType = 'main',
      iconLeft,
      iconRight,
      handleOnClick,
      children,
      dataTestId,
      ...restProps
    },
    forwardedRef,
  ) => {
    const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
      if (typeof handleOnClick === 'function') {
        handleOnClick(e);
      }
      soundEffects.playSound('click');
    };

    const buttonClasses = classNames('button', `button--${btnType}`, className);

    return (
      <div className={`animation-popup button-wrapper ${classNameWrapper}`} data-testid={dataTestId}>
        <button className={buttonClasses} onClick={handleClick} {...restProps} ref={forwardedRef}>
          {iconLeft ? <div className="button__icon-side __left">{iconLeft}</div> : null}
          <div className={classNames('button__content', classNameContent)}>{children}</div>
          {iconRight ? <div className="button__icon-side __right">{iconRight}</div> : null}
        </button>
      </div>
    );
  },
);

OldButton.displayName = 'Button';
